export default {"src":"/_next/static/media/add.4475cd5e.svg","height":60,"width":61,"blurWidth":0,"blurHeight":0};